import { render } from "./ServiceDetails.vue?vue&type=template&id=04be5652&scoped=true"
import script from "./ServiceDetails.vue?vue&type=script&lang=js"
export * from "./ServiceDetails.vue?vue&type=script&lang=js"

import "./ServiceDetails.vue?vue&type=style&index=0&id=04be5652&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04be5652"]])

export default __exports__